// Overhead
import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';
import $ from 'jquery'
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

// Components
import GlobalBanner from '../../components/globalBanner'
import LinnerDiv from '../../components/lineDiv'
import SubHeader from '../../components/subHeader'
import Note from '../../components/note'
import GuestPPLogIn from '../../components/guestPPLogIn'
import ServerErrors from '../../components/ServerErrors';
import AmountWrapper from '../../components/amountWrapper'
import GuestForm from '../guest/guestForm'
import PayCreditOrDebit from '../../components/payCreditOrDebit'
import RecurringCheckBox from '../../components/recurring-checkbox'
import ProgramsContainer from '../../components/programs/ProgramsContainer';

// App Store/Flux
import AppStore from '../../stores/AppStore';
import AppDispatcher from '../../dispatcher/AppDispatcher'
import * as DonateAppActions from '../../actions/AppActions'
import * as AppConstants from '../../utility/constants';
// Utility
import '../../utility/csrf'
import * as amountUtils from '../../components/amount/amountUtils';
import { handleLogIn, handleTokenReuse, addShake, validateDonationAmountForUS, updateDonation } from '../../utility/helper';
import * as FPT from '../../utility/fpt'
import templateData, { localsMessages, isMobileHeaderExp, isOldButtonFactory } from '../../utility/getTemplateData';
import { formatAmount, normalizeNumber, formatCurrency } from '../../utility/formator';
import { DonateGiftAid } from 'guest-payment'
import { showLanguageSelector } from '../../utility/languageSelector';
import withDonate from '../../components/guest/WithDonate';
import TeslaFormContainer from './teslaFormContainer';
import { getParametersFromUrl } from '../../utility/queryStringHelper';

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('routes/guest');
const serviceErrorMessages = localsMessages('errors/service');
const initialData = JSON.parse(document.getElementById('initialData').innerHTML || {});
let giftAidText = localsMessages('common/giftAidIt');
let giftAidTextObj = giftAidText && giftAidText.giftAidIt || {};
let { extraCost } = giftAidTextObj;
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();

class Guest extends React.Component {
	constructor(props) {
		super(props);
		
		this.showErrorOnLoad();
	
		this.state = {
			formattedAmount: this.getFormattedAmount(),
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			showServiceErrors: false,
			errorMessages: [],
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: false,
			country: initialData.selectedCountry,
			selectedCountry: initialData.selectedCountry,
			charityCountry: templateData.charityCountry,
			memberMandatory: templateData.memberMandatory || false,
			accountCreationTriggered: false,

			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			isProgressive: templateData.onboardingEnabled || false,
			isDonating: false,
			isShipping: templateData.isShipping || false,
			shareAddress: {},
			progressiveComponentLoaded: false,
			paymentProcessing: false,
			programNames: templateData.donateContext.program_names
		};
	}
	
	showErrorOnLoad() {
		const url = window.location.href;
		let params = getParametersFromUrl(url);
		
		if (params.showErrorOnLoad) {
			this.setErrorMsg(params.showErrorOnLoad);
			// delete params.showErrorOnLoad;
			
			// const query = $.param(params);
			// const cleanedUrl = `/donate/guest/?${query}`;
			// window.history.replaceState({}, document.title, cleanedUrl);
		}
	}
	
	setErrorMsg(code) {
		if (code === 'fulfillment') {
			// TODO: update error code to the actual fullfilment error code
			let errorCode = 'CHECK_CREDIT_CARD';
			let errorMsgs = [
				{
					key: 0,
					value: serviceErrorMessages[errorCode]
				}
			];

			// adding delay to wait for the dispatcher to get registered in ServerErrors
			setTimeout(
				() => DonateAppActions.updateServerErrors({ serverErrors: errorMsgs }),
				250
			);
		}
	}

	getFormattedAmount = () => {
		const currency = AppStore.getDonationCode() || '';
		const amount = AppStore.getDonationAmount();
		let formattedAmount = '';
		if (amount) {
			formattedAmount = formatAmount({ currency, value: amount })
		}
		return formattedAmount
	}

	componentDidMount() {
		this.props.toggleSpinner(this.state.isProgressive, this.state.isDonating);

		// Only adding page name, if "fptPageName=landing", in other cases track event will be triggered when template is loaded.
		if (templateData.fptPageName === 'landing') {
			FPT.trackPage('main:donate:wps:guest:guestform', 'main:donate:wps:guest:guestform:web::')
		}

		// Checking for recurring status
		if (AppStore.getDonationRecurring() === 'checked') {
			this.setState({ recurringStatus: true }); // eslint-disable-line
		}

		// Checking token status
		handleTokenReuse();

		// Register for App Dispatcher Messages
		this.registerAppDispatcherMessages();

		// Show language selector in the footer
		showLanguageSelector();
	}

	registerAppDispatcherMessages = () => {
		this.dispatcherMessages = AppDispatcher.register((payload) => {
			const actionType = _get(payload, 'action.actionType');

			 if (actionType === 'CHANGE_AMOUNT') {
				const amount = _get(payload, 'action.item.amount', 0);
				this.updateAmount(amount);
			}
			if (actionType === AppConstants.CHANGE_RECURRING) {
				const recurringStatus = _get(payload, 'action.item.recurring', '') === 'checked';
				this.setState({ recurringStatus: recurringStatus });
			}

		});
	}

	getGiftAidExtraAmount(amount) {
		const value = (donateGiftPercentage * normalizeNumber(amount)).toFixed(2);
		const currency = AppStore.getDonationCode();
		return formatCurrency({ value, currency })
	}

	updateGiftAidComponent = (state) => {
		let currency = AppStore.getDonationSymbol();
		let amount = AppStore.getDonationAmount() || 0;
		let extraCostText = extraCost;
		extraCostText = extraCostText && extraCostText.replace(/{currency}/g, currency);
		extraCostText = extraCostText && extraCostText.replace('{amount}', amount);
		extraCostText = extraCostText && extraCostText.replace('{extraAmount}', this.getGiftAidExtraAmount(amount));

		let modalp1 = giftAidTextObj && giftAidTextObj.modalp1 || '',
			modalp2 = giftAidTextObj && giftAidTextObj.modalp2 || '',
			applyGiftAid = giftAidTextObj && giftAidTextObj.applyGiftAid || '';

		modalp1 = modalp1 && modalp1.replace('{orgName}', state.subHeaderLabel);
		modalp2 = modalp2 && modalp2.replace('{orgName}', state.subHeaderLabel);
		applyGiftAid = applyGiftAid && applyGiftAid.replace('{orgName}', state.subHeaderLabel);

		giftAidTextObj.extraCost = extraCostText;
		giftAidTextObj.modalp1 = modalp1;
		giftAidTextObj.modalp2 = modalp2;
		giftAidTextObj.applyGiftAid = applyGiftAid;
	}

	componentWillUnmount() {
		AppDispatcher.unregister(this.dispatcherMessages);
	}

	getFPTDATA = () => {
		return {
			amount: AppStore.getDonationAmount(),
			code: AppStore.getDonationCode(),
			symbol: AppStore.getDonationSymbol()
		}
	};

	updateConversionStatus = (status = false) => {
		this.setState({ donateDisabled: status });
	};

	handleLogIn = (event) => {
		event.preventDefault();

		if (AppStore.getDonationAmount()) {
			FPT.trackLinkClickWithData('guestLogIn', {
				amount: AppStore.getDonationAmount(),
				code: AppStore.getDonationCode(),
				symbol: AppStore.getDonationSymbol()
			})
		}

		// Proceed to Login only if the donation amount is valid
		if (this.validateDonationAmount()) {
			handleLogIn();
		}
	};

	/**
	 * Display validation error
	 */
	displayValidationError = () => {
		const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
		this.setState({
			showValidationError: true,
			validationErrorMessage: errorMessage
		});
		addShake();
	};

	hideValidationError = () => {
		this.setState({ showValidationError: false })
	};

	/**
	 * Validates donation amount and displays the validation error if any
	 */
	validateDonationAmount = () => {
		if (templateData.donationCode === 'USD') {
			if (validateDonationAmountForUS()) {
				this.setState({
					showValidationError: false,
					validationErrorMessage: ''
				});
				return true;
			}
			this.displayValidationError();
			return false;
		}
		if (!amountUtils.isAmountGreaterThanZero(AppStore.getDonationAmount())) {
			this.setState({
				showValidationError: true,
				validationErrorMessage: messages.error.amount
			});
			addShake();
			return false;
		}

		return true;
	};

	handleRecurringChange = (status = false) => {
		DonateAppActions.changeRecurring({
			recurring: status ? 'checked' : 'unchecked'
		});
	};

	/**
	 * Clear the validation error onFocus
	 */
	handleAmountFocus = () => {
		if (this.state.showValidationError) {
			this.hideValidationError();
		}
	};

	validateAmountV2 = () => {
		if (!this.validateDonationAmount()) {
			$('html, body').animate({ scrollTop: $('.money_input').offset().top	}, 1000);
			addShake()
			return false; // block account creation
		}

		if (!amountUtils.isAmountGreaterThanZero(AppStore.getDonationAmount())) {
			addShake()
			$('html, body').animate({ scrollTop: $('.money_input').offset().top	}, 1000);
			return false; // block account creation
		}

		return true;
	}

	/*
	* handlePaymentSuccess
	*/
	handlePaymentSuccess = (response) => {
		if (response.isOfacPending) {
			return this.props.history.push('/donate/guest/pending')
		}

		return this.props.history.push('/donate/guest/confirmation');
	};

	/*
	* handlePaymentFailure
	*/
	handlePaymentFailure = (response) => {
		return this.props.history.push('/donate/error/payment');
	};

	/*
	* handleMemberFailure
	* Redirect all member failure to donate/member
	* Known case
	* Case 1 :- WSM_PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE
	* Case 2 :- WSM_VALIDATION_ERROR
	*/
	handleMemberFailure = () => {
		updateDonation(`/donate/member?token=${templateData.token}`);
	};

	updateAmount(amount) {
		const currency = AppStore.getDonationCode() || '';
		this.setState({
			formattedAmount: formatAmount({ currency, value: amount })
		})
	}

	handleGiftAidOption(giftAidState) {
		DonateAppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
	}

	/**
	* Should show note when charityNote is enabled and recurring is disabled
	* @return {Boolean} true to show note field
	*/
	shouldShowNote = () => {
		return templateData.charityNoteEnabled && !this.state.recurringStatus;
	};

	createMarkup = (str) => {
		return {
			__html: str
		};
	}

	renderProgramsDropdown = () => {
		if (isOldButtonFactory() || _isEmpty(this.state.programNames)) {
			return null;
		}

		return <ProgramsContainer
			programNames={this.state.programNames}
		/>

	}

	render() {
		const errorgeneric = errorMessages.error && errorMessages.error.generic || '';
		const recurringStatus = AppStore.getDonationRecurring() === 'checked';

		if (templateData.isGiftaiditEnabled) {
			this.updateGiftAidComponent(this.state);
		}
		
		return (
			<div className={`donate_wrapper ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
				<div className="container">
					<ServerErrors />
					<GlobalBanner
						logourl={this.state.logourl}/>
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}
						page="guest"/>
					<form id="guestForm" className="donate_guest_form" noValidate>
						<AmountWrapper
							conversionStatus={this.updateConversionStatus}
							validateDonationAmount={this.validateDonationAmount}
							showValidationError={this.state.showValidationError}
							hideValidationError={this.hideValidationError}
							validationErrorMessage={this.state.validationErrorMessage}
							onFocus={this.handleAmountFocus}
						/>
						<p className="err_update_amount text-center">{errorgeneric}</p>

						{this.renderProgramsDropdown()}
						{this.state.recurringEnabled &&
							<RecurringCheckBox
								toolTipText={this.state.recurringHelpText}
								label={this.state.recurringLabel}
								status={this.state.recurringStatus}
								handleChange={this.handleRecurringChange}
								hasRecurringHelp={false}
								showNote={true}
							/>
						}

						{templateData.isGiftaiditEnabled && <DonateGiftAid
							isAlreadyEnrolled={false}
							showAddress={false}
							addressData='' // eslint-disable-line
							isChecked={false}
							handleGiftAidOption={this.handleGiftAidOption}
							contentMsg={giftAidTextObj}/>
						}
						<LinnerDiv />
						{this.shouldShowNote() ? <Note /> : null}
						<GuestPPLogIn handleLogIn={this.handleLogIn}/>
						<PayCreditOrDebit />

						{!this.state.isProgressive &&
							<div className="donate_guest_form">
								<GuestForm
									recurringStatus={recurringStatus}
									donateDisabled={this.state.donateDisabled}
									validateDonationAmountForUS={this.validateDonationAmount}
								/>
							</div>
						}
					</form>
					{this.state.isProgressive &&
						<TeslaFormContainer
							displayValidationError={this.displayValidationError}
							validateDonationAmount={this.validateDonationAmount}
							validateAmountV2={this.validateAmountV2}
							handlePaymentSuccess={this.handlePaymentSuccess}
							handlePaymentFailure={this.handlePaymentFailure}
							handleMemberFailure={this.handleMemberFailure}
						/>
					}
				</div>
			</div>
		)
	}
}

Guest.propTypes = {
	toggleSpinner: PropTypes.func,
	history: PropTypes.object
};

export default withRouter(withDonate(Guest));



// WEBPACK FOOTER //
// ./pages/guest/guest.js